<template>
    <component :is="component" :detectionData="detectionData" :paginationData="paginationData" :itemData="itemData" v-if="component"></component>
</template>

<script>
export default {
    name: "DetectionListLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        listLayout: '',
        detectionData: {default: () => []},
        paginationData: {default: {page: 1, size: 10, total: 0}},
        itemData: {default: () => {}},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/detection/list/DetectionListDefaultLayout')
                })

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/detection/list/${this.listLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
